import Clock from '@crehana/compass.icons.fill/Clock';
import ArrowUp from '@crehana/compass.icons.outline/ArrowUp';
import { Button } from '@crehana/compass.ui/button';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export var SubmitButton = function SubmitButton(_ref) {
  var _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'submit' : _ref$type,
    onClick = _ref.onClick,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 20 : _ref$iconSize,
    ariaLabel = _ref.ariaLabel;
  return /*#__PURE__*/_jsx(Button, {
    className: clsx('tw-bg-neutral-light-300 tw-text-neutral-light-800 hover:tw-bg-primary-light-700 hover:tw-text-neutral-light-100 tw-rounded-full tw-p-0.8 disabled:!tw-bg-neutral-light-300 disabled:!tw-text-neutral-light-500', className),
    disabled: disabled || isLoading,
    type: type,
    onClick: onClick,
    "aria-label": ariaLabel || 'submit button',
    children: isLoading ? /*#__PURE__*/_jsx(Clock, {
      size: iconSize,
      className: "tw-text-current"
    }) : /*#__PURE__*/_jsx(ArrowUp, {
      size: iconSize,
      className: "tw-text-current"
    })
  });
};